<template>
    <div>
        <div class="content">
            <div class="title-box">
                <h3>{{auditTrailLan.indexText}}</h3>
            </div>
            <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
                <mtable v-if="trData"
                :thData="thData"
                :trData="trData"
                :link="link"
                :back="back"
                :page="page"
                :selPage="selPage"
                :multiLanguage="auditTrailLan"
                :downLoadTran="downLoadTran"
                :jsonExcelAjax="jsonExcelAjax"
                :name="name"
                @tableChange="tableAjax">
                    <div slot="handle" class="slotDiv">
                        <div class="selectDiv">
                            <span>{{auditTrailLan.type}}</span>
                            <el-select v-model="category" style="width:80px" @change="searchDatas">
                                <el-option
                                v-for="(key,val) in auditTrailLan.category"
                                :key="val"
                                :label="key"
                                :value="val">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="inputDiv">
                            <div class="searchDiv">
                                <span>{{auditTrailLan.account}}</span>
                                <el-input v-model="account" style="width: 150px;"></el-input>
                            </div>
                            <div class="searchDiv">
                                <span>{{auditTrailLan.start_time}}</span>
                                <el-date-picker v-model="start_time"
                                type="datetime"
                                :placeholder="auditTrailLan.selectTimeText"
                                style="width: 190px">
                                </el-date-picker>
                            </div>
                            <div class="searchDiv">
                                <span>{{auditTrailLan.end_time}}</span>
                                <el-date-picker v-model="end_time"
                                type="datetime" 
                                :placeholder="auditTrailLan.selectTimeText"
                                style="width: 190px">
                                </el-date-picker>
                            </div>
                            <div class="btnDiv">
                                <el-button type="primary" :disabled="!start_time || !end_time" @click="searchDatas">
                                {{auditTrailLan.search}}
                                </el-button>
                            </div>     
                        </div>                                           
                    </div>
                </mtable>
            </div>
        </div>
    </div>
</template>
<script>
import mtable from "../../comm/mytable"
import {URL_AUDITREPORT} from 'api/commissionApi'
import {formatDate,getTimeDiff, updateTimeByUtc} from 'common/js/util'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
    name:'auditTrailReport',
    mixins: [
      require("common/mixin/base.js").base({auditTrailLan: "auditTrailReport"})
    ],
    props: ['curArea'],
    data(){
        return {
            trData:[],
            category: "-1",
            account: '',
            start_time: new Date(new Date().getTime() - 30*24*60*60*1000),
            end_time: new Date(),
            url: '',
            loading: true,
            changeTime: false,
            link:{
                key: ['MODIFIED_ID'],
                path:'auditTrailDetailReport'
            },
            page: {
                active: 1,
                pageLeng: 0
            },
            selPage: {
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            }
        }
    },
    computed: {
        back(){
            return JSON.stringify({
                path:'auditTrailReport',
                begintime: this.start_time,
                endtime: this.end_time,
                pageNum: this.page.active - 1,
                pageSize: this.selPage.limit,
                type: this.category,
                id: this.account
            })
        },
        name(){
            return this.auditTrailLan.indexText
        },
        thData(){
            return this.auditTrailLan.indexTh
        },
        downLoadTran(){
            return { TYPE: this.auditTrailLan.category}
        },
        jsonExcelAjax(){
            return {
                url: this.url,
                ajaxType: "get",
                getKey: ["data", "data","data"],
                ajaxPar: {
                    lang: this.LANGUAGE,
                    begintime: formatDate(this.start_time),
                    endtime: formatDate(this.end_time),
                    pageNum: 0,
                    pageSize: this.page.pageLeng,
                    type: this.category,
                    id: this.account
                }
            }
        }
    },
    mounted() {
        if(sessionStorage.getItem('back')){
            let backObj = JSON.parse(sessionStorage.getItem('back'))
            if(backObj.path === 'auditTrailReport'){
                this.category = backObj.type
                this.account = backObj.id
                this.start_time = backObj.begintime
                this.end_time = backObj.endtime
                this.page.active = backObj.pageNum + 1
                this.selPage.limit = backObj.pageSize
            }    
            this.tableAjax()
            sessionStorage.removeItem('back')
        }else{
            this.tableAjax()
        }
    },
    methods: {
        searchDatas(){
            this.loading = true
            this.page.active = 1
            this.tableAjax()
        },
        tableAjax(){
            this.changeTime = true
            this.url = api.getUrl20(this.curArea, URL_AUDITREPORT)
            let tableObj = {
                params: {
                    begintime: formatDate(this.start_time),
                    endtime: formatDate(this.end_time),
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit,
                    type: this.category,
                    id: this.account
                }
            }
            this.$http.get(this.url, tableObj).then((res) => {
                this.trData = res.data.data.data
                this.page.pageLeng = res.data.data.count
                this.setOfficeState()
                this.loading = false
            })
        },
        setOfficeState(){
            let list = this.auditTrailLan.category
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach((item,index) =>{
                    let temp = this.trData[index]
                    temp.type = (temp.TYPE || temp.TYPE == 0) ? list[temp.TYPE] : ''
                    if(this.changeTime){
                        temp.begintime = updateTimeByUtc(getTimeDiff(),temp.begintime)
                        temp.endtime = updateTimeByUtc(getTimeDiff(),temp.endtime)
                    }
                }) 
            }
        }
    },
    watch: {
        auditTrailLan(){
            this.changeTime = false
            this.setOfficeState()
        },
        curArea(){
            this.type = '-1'
            this.account = ''
            this.start_time = new Date(new Date().getTime() - 30*24*60*60*1000)
            this.end_time = new Date()
            this.page.active = 1
            this.loading = true
            this.tableAjax()
        }
    },
    components: {
        mtable
    }
}
</script>
<style lang="scss" scoped>
    .title-box{
        border: 1px solid #3F51B5;
        background: #3F51B5;
        padding: 0 20px;
        color: #fff;
        border-radius: 5px 5px 0 0;
    }
    .slotDiv{
        float: left;
        .selectDiv{
            float: left;
        }
        .inputDiv{
            float: left;
            margin-left: 10px;
            .searchDiv{
                float: left;
                margin-right: 10px;
            }
            .btnDiv{
                float: left;
                margin-right: 30px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// auditTrailReport.vue?30ef48b7